import React, { useState, useRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useClickOutside } from '@/hooks/useClickOutside';
import { useAppSelector } from '@/configureStore';
import { selectUserIsLoggedIn, useGetCurrentUserQuery } from '@/stores/currentUserApi';
import { UserDropdown } from './UserDropdown';
import styles from './UserArea.module.scss';
import LoginPopup from './LoginPopup';

export const UserArea = () => {
  const { t } = useTranslation();
  // An active subscription is required to keep the query data in the cache
  const {} = useGetCurrentUserQuery();
  const isLoggedIn = useAppSelector((state) => selectUserIsLoggedIn(state));
  const [showLogin, setShowLogin] = useState(false);
  const loginRef = useRef(null);

  useClickOutside(loginRef, () => {
    setShowLogin(false);
  });

  const toggleLoginPopup = () => {
    setShowLogin(!showLogin);
  };

  return (
    <div ref={loginRef}>
      {isLoggedIn ? (
        <UserDropdown />
      ) : (
        <button
          className={`btn btn-link d-flex ${styles.dropdownToggle}`}
          aria-haspopup="true"
          aria-expanded={showLogin}
          data-toggle="dropdown"
          type="button"
          onClick={toggleLoginPopup}
        >
          <span className={`${styles.userName} text-sans-serif`}>
            <span className="fa fa-user mr-2"></span>
            {t('common:actions.login')}
          </span>
        </button>
      )}

      {showLogin && !isLoggedIn && (
        <div className={styles.loginPopup}>
          <LoginPopup />
        </div>
      )}
    </div>
  );
};
